<template>
  <div class="form-dialog">
    <div class="form-body-scroll">
      <div
        class="form-text-title"
        style="position: relative;"
      >
        <div
          class="hide-icon-new"
          @click="_cancelClick"
        >
          <!-- <label
            for="angleDown"
            class="label-hover"
          >
            <v-icon
              name="angle-down"
              scale="1"
              class="icon-padding"
            />
          </label>-->
        </div>
      </div>
      <div class="form-text-title-h1-contact padding-title-contact">
        Contacto
      </div>
      <div class="form-box-body">
        <vuescroll>
          <div class="form-components scroll">
            <div>
              <div
                class="form_label"
              >
                <div class="requered_text">
                  *
                </div>Nombre
              </div>
              <div
                class="form__field"
                :class="{ 'form__field--filled': usuarioNombre }"
              >
                <input
                  id="username"
                  ref="username"
                  v-model="usuarioNombre"
                  :class="{ 'form__field-input--filled': usuarioNombre }"
                  autocomplete="off"
                  type="text"
                  name="username"
                  placeholder="Nombre"
                  required
                  maxlength="50"
                  @keypress="keyPressCheckSpecialChars($event, 'name')"
                  @keyup.enter="focusTo('mail')"
                >
              </div>
              <div
                class="form_label"
              >
                <div class="requered_text">
                  *
                </div>Correo electrónico
              </div>
              <div
                class="form__field"
                :class="{ 'form__field--filled': usuarioEmail }"
              >
                <input
                  id="mail"
                  ref="mail"
                  v-model="usuarioEmail"
                  :class="{ 'form__field-input--filled': usuarioEmail }"
                  autocomplete="off"
                  type="text"
                  name="mail"
                  maxlength="50"
                  value
                  placeholder="Email"
                  required
                  @keypress="keyPressCheckSpecialChars($event, 'email')"
                  @keyup.enter="focusTo('telefono')"
                >
              </div>
              <div
                class="form_label"
              >
                <div class="requered_text">
                  *
                </div>Teléfono
              </div>
              <div
                class="form__field"
                :class="{ 'form__field--filled': usuarioTelefono }"
              >
                <input
                  id="telefono"
                  ref="telefono"
                  v-model="usuarioTelefono"
                  :class="{ 'form__field-input--filled': usuarioTelefono }"
                  autocomplete="off"
                  type="text"
                  name="telefono"
                  value=""
                  placeholder="xx 1234 5678"
                  maxlength="20"
                  required
                  @keypress="keyPressCheckSpecialChars($event, 'phone')"
                  @change="cleanSpecialChars('telefono', 'phone')"
                  @keyup.enter="_sentClick"
                >
              </div>
              <div
                class="form_label"
              >
                <div class="requered_text">
                  *
                </div>Motivo de contacto
              </div>
              <div
                class="form__field"
                :class="{ 'form__field--filled': motivoContacto }"
              >
                <input
                  id="motivo"
                  ref="motivo"
                  v-model="motivoContacto"
                  :class="{ 'form__field-input--filled': motivoContacto }"
                  autocomplete="off"
                  type="text"
                  name="motivo"

                  value=""
                  placeholder="Ingresa motivo"
                  maxlength="50"
                  required
                  @keypress="keyPressCheckSpecialChars($event, 'comment')"
                  @change="cleanSpecialChars('motivo', 'comment')"
                  @keyup.enter="focusTo('pais')"
                >
              </div>
              <div
                class="form_label"
              >
                <div class="requered_text">
                  *
                </div>País
              </div>
              <div
                class="form__field"
                :class="{ 'form__field--filled': usuarioPais }"
              >
                <input
                  id="pais"
                  ref="pais"
                  v-model="usuarioPais"
                  :class="{ 'form__field-input--filled': usuarioPais }"
                  autocomplete="off"
                  type="text"
                  name="pais"
                  value=""
                  placeholder="Ingresa país"
                  maxlength="50"
                  required
                  @keypress="keyPressCheckSpecialChars($event, 'paises')"
                  @change="cleanSpecialChars('pais', 'paises')"
                  @keyup.enter="_sentClick"
                >
              </div>
              <div
                class="form_label"
              >
                Organización
              </div>
              <div
                class="form__field"
                :class="{ 'form__field--filled': usuarioOrganizacion }"
              >
                <input
                  id="Organizacion"
                  ref="Organizacion"
                  v-model="usuarioOrganizacion"
                  :class="{ 'form__field-input--filled': usuarioOrganizacion }"
                  autocomplete="off"
                  type="text"
                  name="Organizacion"
                  value=""
                  placeholder="Ingresa organización"
                  maxlength="50"
                  required
                  @keypress="keyPressCheckSpecialChars($event, 'comment')"
                  @change="cleanSpecialChars('Organizacion', 'comment')"
                >
              </div>
              <div
                class="form_label"
              >
                <div class="requered_text">
                  *
                </div>Cuéntanos acerca de tu consulta,<br>duda o sugerencia
              </div>
              <div
                class="form__field"
                :class="{ 'form__field--filled': comentario }"
              >
                <textarea
                  ref="comentario"
                  v-model="comentario"
                  :class="{ 'form__field-textarea--filled': comentario }"
                  style="white-space: pre-line"
                  placeholder="Escribe tu solicitud..."
                  maxlength="220"
                />
                <div class="contador">
                  {{ comentario.length }}/{{ maxCaracteres }}
                </div>
              </div>
              <vue-recaptcha
                :sitekey="recaptchaSiteKey"
                :load-recaptcha-script="true"
                class="g-recaptcha custom-recaptcha"
              />
            </div>
          </div>
        </vuescroll>
      </div>
      <!-- BOTONES -->
      <div class="form-box-button scroll margin_btn">
        <button
          class="button-secondary"
          @click="_cancelClick"
        >
          Cancelar
        </button>
        <button
          class="button-primary"
          @click="_sentClick"
        >
          Enviar
        </button>
      </div>
      <!-- MSG -->
      <div class="form-error">
        &nbsp;{{ errormsg }}
      </div>
    </div>
  </div>
</template>
<script>
import { serverUI } from '../../main'
import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons/user'
import 'vue-awesome/icons/envelope'
import 'vue-awesome/icons/comment'
import 'vue-awesome/icons/shipping-fast'
import formUtils from '../../formUtils'
import utils from '../../utils'
import VueRecaptcha from 'vue-recaptcha'

export default {
  components: {
    'v-icon': Icon,
    VueRecaptcha
  },
  props: {},
  methods: {
    ...formUtils.formBase,
    _sentClick () {
      this.errormsg = ''
      if (!this.usuarioNombre || this.usuarioNombre === 'Visita' || this.usuarioNombre === '') {
        this.errormsg = 'Debes ingresar tu nombre'
        this.$refs.username.focus()
        return
      }
      /* if (!this.telefono) {
        this.errormsg = 'Debes ingresar el teléfono'
        return
      } */
      if (!this.usuarioEmail) {
        this.errormsg = 'Debes ingresar un correo'
        this.$refs.mail.focus()
        return
      }
      if (!utils.isEmail(this.usuarioEmail)) {
        this.errormsg = 'Formato de correo incorrecto'
        this.$refs.mail.focus()
        return
      }
      if (!this.usuarioTelefono && this.usuarioTelefono.length <= 8) {
        this.errormsg = 'Debes ingresar teléfono válido'
        this.$refs.telefono.focus()
        return
      }
      if (!this.motivoContacto) {
        this.errormsg = 'Debes ingresar un motivo'
        this.$refs.motivo.focus()
        return
      }
      if (!this.usuarioPais) {
        this.errormsg = 'Debes ingresar tu país'
        this.$refs.pais.focus()
        return
      }

      if (!this.comentario || this.comentario.length < 5) {
        this.errormsg = 'Debes ingresar tu solicitud'
        this.$refs.comentario.focus()
        return
      }

      const responseCaptcha = window.grecaptcha.getResponse()
      if (responseCaptcha.length === 0) {
        this.errormsg = 'Debes validar que no eres un robot.'
        return
      }
      const dataToSend = {
        form: 'A2censoContactForm',
        evento: 'sentClick',
        data: {
          type: 'a2censo-contact-form-confirm',
          fields: {
            nombre: this.usuarioNombre,
            telefono: this.usuarioTelefono,
            email: this.usuarioEmail,
            motivo: this.motivoContacto,
            pais: this.usuarioPais,
            organizacion: this.usuarioOrganizacion,
            comentario: this.comentario
          }
        }
      }

      serverUI.$emit('FormEvent', dataToSend)
    },
    _cancelClick () {
      serverUI.$emit('FormEvent', {
        form: 'A2censoContactForm',
        evento: 'cancelClick',
        dato: 'Cancelado'
      })
    },
    onRecaptchaVerified (response) {
      console.log('reCAPTCHA verificado, respuesta:', response)
      // Puedes enviar la respuesta al backend aquí
    },
    onRecaptchaVerified2 () {
      const response = window.grecaptcha.getResponse()
      if (response.length === 0) {
        this.errormsg = 'Debes validar si no eres un robot.'
      } else {
        // Manejar la respuesta del reCAPTCHA aquí
        console.log('reCAPTCHA response:', response)
      }
    }

  },
  data () {
    return {
      title: '',
      text: '',
      errormsg: '',
      usuarioNombre: '',
      usuarioEmail: '',
      usuarioTelefono: '',
      motivoContacto: '',
      usuarioPais: '',
      usuarioOrganizacion: '',
      comentario: '',
      recaptchaSiteKey: '6LeWzv8oAAAAAMK7m4K0qv4FLSNpJPTby5z92LVB',
      maxCaracteres: 220
    }
  },
  computed: {},
  created () {
    // Señales recibidas
    serverUI.$on('FormEvent', (e) => {
      if (e.form !== 'A2censoContactForm') return
      if (e.evento === 'newdata') {
        this.title = e.dato.title ? e.dato.title : 'Contacto'
        this.text = e.dato.text ? e.dato.text : ''
        this.title = e.dato.title ? e.dato.title : 'Contacto'
        this.text = e.dato.text ? e.dato.text : ''
        this.nombreOrigen = e.dato.fields.name ? e.dato.fields.name : ''
        this.emailOrigen = e.dato.fields.email ? e.dato.fields.email : ''
        this.telefonoOrigen = e.dato.fields.phone
          ? e.dato.fields.phone
          : ''
        this.usuarioNombre = this.nombreOrigen
        this.usuarioEmail = this.emailOrigen
        this.usuarioTelefono = this.telefonoOrigen
      }
    })
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>
.form__field {
	margin-bottom: 7px;
}

.form-box-body {
	height: 370px;
}
.contador {
  bottom: -40px;
  right: 10px;
  font-size: 12px;
  position: relative;
  color: #475061;
}
</style>
